module.exports = __webpack_public_path__ + "img/detail.4d63ec55.png";